/**
 * @ element-ui 按需引入
 */
import Vue from 'vue'

import {
  Button,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Card,
  Dialog,
  Popover,
  Loading,
  MessageBox,
  Message,
  Breadcrumb,
  BreadcrumbItem,
  Steps,
  Step,
  Notification,
  Pagination,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Image,
  Upload,
} from 'element-ui';

Vue.use(Button)
  .use(Form)
  .use(FormItem)
  .use(Select)
  .use(Option)
  .use(Input)
  .use(RadioGroup)
  .use(Radio)
  .use(CheckboxGroup)
  .use(Checkbox)
  .use(Card)
  .use(Dialog)
  .use(Popover)
  .use(Loading.directive)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(Steps)
  .use(Step)
  .use(Pagination)
  .use(Table)
  .use(TableColumn)
  .use(Tabs)
  .use(TabPane)
  .use(Image)
  .use(Upload)

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;



// WEBPACK FOOTER //
// ./src/elementUI.js